import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Separator } from "@/components/ui/separator";
import { Textarea } from "@/components/ui/textarea";
import { useState } from 'react';

const DEFAULT_REQUEST_HEADERS = `Content-Type: application/json
Authorization: Bearer YOUR_TOKEN`;

const DEFAULT_REQUEST_BODY = `{
  "key": "value",
  "anotherKey": 123,
  "nestedObject": {
    "nestedKey": "nestedValue"
  }
}`;

const HttpPingConfig = ({ stepKey, updateStepData, getStepData }) => {
    const stepData = getStepData(stepKey);
    const [showRequestHeaders, setShowRequestHeaders] = useState(stepData.requestHeaders ? true : false);
    const [showRequestBody, setShowRequestBody] = useState(stepData.requestBody ? true : false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newData = { ...stepData, [name]: value };
        updateStepData(stepKey, newData);
    };

    const handleSelectChange = (field, value) => {
        const newData = { ...stepData, [field]: value };
        updateStepData(stepKey, newData);
    };

    const handleRequestHeadersChange = (e) => {
        const { value } = e.target;
        const newData = { ...stepData, requestHeaders: value };
        updateStepData(stepKey, newData);
    };

    const handleRequestBodyChange = (e) => {
        const { value } = e.target;
        const newData = { ...stepData, requestBody: value };
        updateStepData(stepKey, newData);
    };

    const toggleRequestHeaders = () => {
        setShowRequestHeaders(!showRequestHeaders);
        if (!showRequestHeaders && !stepData.requestHeaders) {
            updateStepData(stepKey, { ...stepData, requestHeaders: DEFAULT_REQUEST_HEADERS });
        } else if (showRequestHeaders) {
            updateStepData(stepKey, { ...stepData, requestHeaders: '' });
        }
    };

    const toggleRequestBody = () => {
        setShowRequestBody(!showRequestBody);
        if (!showRequestBody && !stepData.requestBody) {
            updateStepData(stepKey, { ...stepData, requestBody: DEFAULT_REQUEST_BODY });
        } else if (showRequestBody) {
            updateStepData(stepKey, { ...stepData, requestBody: '' });
        }
    };

    return (
        <>
            <div className="flex flex-col space-y-3">
                <Label htmlFor="hostname">URL to monitor</Label>
                <div className="flex space-x-2">
                    <Select
                        value={stepData.method || 'GET'}
                        onValueChange={(value) => handleSelectChange('method', value)}
                    >
                        <SelectTrigger className="w-24 rounded-r-none flex-shrink-0 text-xs">
                            <SelectValue placeholder="GET" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="GET" className="text-xs">GET</SelectItem>
                            <SelectItem value="POST" className="text-xs">POST</SelectItem>
                            <SelectItem value="PUT" className="text-xs">PUT</SelectItem>
                            <SelectItem value="DELETE" className="text-xs">DELETE</SelectItem>
                        </SelectContent>
                    </Select>
                    <Select
                        value={stepData.protocol || 'https:'}
                        onValueChange={(value) => handleSelectChange('protocol', value)}
                    >
                        <SelectTrigger className="w-28 rounded-none flex-shrink-0 text-xs">
                            <SelectValue placeholder="https:" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="https:" className="text-xs">HTTPS://</SelectItem>
                            <SelectItem value="http:" className="text-xs">HTTP://</SelectItem>
                        </SelectContent>
                    </Select>
                    <Input
                        id="hostname" 
                        name="hostname"
                        value={stepData.hostname || ''}
                        onChange={handleInputChange} 
                        placeholder="example.com/path/to/resource"
                        className="flex-grow rounded-l-none"
                    />
                </div>
            </div>
            <Separator />
            {showRequestHeaders ? (
                <div className="flex flex-col space-y-3">
                    <Label htmlFor="requestHeaders" className="flex items-center justify-between">
                        <div>Request headers <span className="text-xs text-muted-foreground ml-1">(one per line)</span></div>
                        <button className="ml-2 text-xs text-muted-foreground underline-offset-4 hover:underline" onClick={toggleRequestHeaders}>
                            Remove Headers
                        </button>
                    </Label>
                    <Textarea
                        id="requestHeaders"
                        name="requestHeaders"
                        value={stepData.requestHeaders || DEFAULT_REQUEST_HEADERS}
                        onChange={handleRequestHeadersChange}
                        placeholder="Content-Type: application/json
Authorization: Bearer YOUR_TOKEN"
                        className="min-h-36 font-mono text-xs"
                    />
                </div>
            ) : (
                <div className="flex items-center space-x-2">
                    <Checkbox 
                        id="addRequestHeaders" 
                        checked={showRequestHeaders}
                        onCheckedChange={toggleRequestHeaders}
                    />
                    <Label htmlFor="addRequestHeaders" className="cursor-pointer">Add request headers</Label>
                </div>
            )}
            {showRequestBody ? (
                <div className="flex flex-col space-y-3">
                    <Label htmlFor="requestBody" className="flex items-center justify-between">
                        <div>Request body</div>
                        <button className="ml-2 text-xs text-muted-foreground underline-offset-4 hover:underline" onClick={toggleRequestBody}>
                            Remove Request Body
                        </button>
                    </Label>
                    <Textarea
                        id="requestBody"
                        name="requestBody"
                        value={stepData.requestBody || DEFAULT_REQUEST_BODY}
                        onChange={handleRequestBodyChange}
                        placeholder={`{
  "key": "value",
  "anotherKey": 123,
  "nestedObject": {
    "nestedKey": "nestedValue"
  }
}`}
                        className="min-h-36 font-mono text-xs"
                    />
                </div>
            ) : (
                <div className="flex items-center space-x-2">
                    <Checkbox 
                        id="addRequestBody" 
                        checked={showRequestBody}
                        onCheckedChange={toggleRequestBody}
                    />
                    <Label htmlFor="addRequestBody" className="cursor-pointer">Add request body</Label>
                </div>
            )}
        </>
    );
};

export default HttpPingConfig; 